import { render } from "./CsatOverallRating.vue?vue&type=template&id=15c2dc3f"
import script from "./CsatOverallRating.vue?vue&type=script&lang=js"
export * from "./CsatOverallRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__